import { Injector, ModuleWithProviders, NgModule, Type } from '@angular/core';
import { serverEventsProviderFactory } from './factories';
import {
  AbstractPusherConfigService,
  PusherApiService,
  PusherClientService,
  ServerEventsProviderService,
} from './services';

@NgModule({
})
export class ServerEventsModule {
  static usePusher(config: Type<AbstractPusherConfigService>): ModuleWithProviders<ServerEventsModule> {
    return {
      ngModule: ServerEventsModule,
      providers: [
        { provide: AbstractPusherConfigService, useClass: config },
        PusherApiService,
        PusherClientService,
        {
          provide: ServerEventsProviderService,
          useFactory: serverEventsProviderFactory,
          deps: [Injector]
        }
      ],
    };
  }
}
